import { RefreshCw } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

export const AppUpdatePrompt = () => {
  const [updateReady, setUpdateReady] = useState(false);
  const reloadRequested = useRef(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'app-update-ready' && navigator.serviceWorker.controller) setUpdateReady(true);
    };
    const handleControllerChange = () => {
      if (reloadRequested.current) window.location.reload();
    };
    navigator.serviceWorker.addEventListener('message', handleMessage);
    navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
      navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
    };
  }, []);

  const applyUpdate = async () => {
    reloadRequested.current = true;
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration?.waiting) registration.waiting.postMessage({ type: 'skip-waiting' });
    else window.location.reload();
  };

  if (!updateReady) return null;
  return (
    <aside className="fixed inset-x-3 top-3 z-[90] mx-auto flex min-h-[56px] max-w-md items-center gap-3 rounded-md border border-field-blue bg-white px-4 py-3 shadow-lg" role="status">
      <RefreshCw className="shrink-0 text-field-blue" size={20} aria-hidden="true" />
      <p className="min-w-0 flex-1 text-sm font-bold text-ink">A new DeadBird version is ready.</p>
      <button type="button" onClick={() => void applyUpdate()} className="min-h-11 shrink-0 rounded-md bg-field-blue px-3 font-bold text-white">Update</button>
    </aside>
  );
};
